var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { User } from 'packages/users/User';
import { Tag } from 'packages/company/entities/Tag';
import { CandidateAttachedAttribute } from './CandidateAttachedAttribute';
import moment from 'moment';
/**
 * Status
 *
 * Possible statuses that a Talent can have,
 * mirrors the structure of the back-end API.
 */
export var Status;
(function (Status) {
    Status["unknown"] = "unknown";
    Status["hire"] = "hire";
    Status["known"] = "known";
    Status["lead"] = "lead";
    Status["qualified"] = "qualified";
})(Status || (Status = {}));
var Talent = /** @class */ (function (_super) {
    __extends(Talent, _super);
    function Talent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.companyId = null;
        _this.chatId = null;
        _this.email = null;
        _this.name = null;
        _this.phone = null;
        _this.source = null;
        _this.status = Status.unknown;
        _this.score = null;
        _this.totalApplications = null;
        _this.lastContacted = null;
        _this.lastJobApplied = null;
        _this.tags = [];
        // Some of our endpoints return tag ids and some tags, therefore we have both in the entity.
        _this.tagIds = [];
        _this.createdAt = null;
        _this.attributes = [];
        return _this;
    }
    Object.defineProperty(Talent.prototype, "user", {
        get: function () {
            return EntityBuilder.buildOne(User, {
                name: this.name,
                email: this.email,
                phone: this.phone,
                source: this.source,
                createdAt: this.createdAt,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Talent.prototype, "displayName", {
        get: function () {
            var _a;
            return (_a = this.name) !== null && _a !== void 0 ? _a : this.email;
        },
        enumerable: false,
        configurable: true
    });
    Talent.prototype.toJdsStructure = function (availableTags) {
        var lookupTag = function (id) { return availableTags.find(function (t) { return t.id === id; }); };
        return {
            name: this.name,
            enteredAt: moment(this.createdAt).toDate(),
            tags: this.tagIds.map(function (id) {
                var tag = lookupTag(id);
                if (!tag) {
                    return null;
                }
                return {
                    name: tag.label,
                    color: tag.color,
                };
            }).filter(function (t) { return t !== null; }),
            counters: {
                emails: 0,
                comments: 0,
                files: 0,
            },
        };
    };
    __decorate([
        Type(Tag),
        __metadata("design:type", Array)
    ], Talent.prototype, "tags", void 0);
    __decorate([
        Type(CandidateAttachedAttribute),
        __metadata("design:type", Array)
    ], Talent.prototype, "attributes", void 0);
    return Talent;
}(Entity));
export { Talent };
